<!-- Default loader -->
<div *ngIf="(combinedLoader$ | async) === 'default'" class="overlay">
    <div class="loader">
      <div class="spinner"></div>
    </div>
  </div>
  
  <!-- Calculator loader -->
  <div *ngIf="(combinedLoader$ | async) === 'calculator'" class="overlay">
    <div class="loader">
      <div class="calculator-loader-background"></div>
    </div>
    <div class="text-container-premium loaderCnt">
      <p class="text-dark fontSize15px"><b>{{ premiumCnt }}</b></p>
    </div>
  </div>
  